import OrderDetailComp from '../../../Components/Order/OrderDetail';

const OrderDetail = () => {
  return (
    <div>
      <OrderDetailComp />
      {/* Additional NewOrder-specific UI */}
    </div>
  );
};

export default OrderDetail;
